import { useNavigate } from "react-router-dom"
import Button from "@/components/Button/Button"
import StatusScreen from "@/components/StatusScreen/StatusScreen"
import { ROUTES } from "@/routes/routes"
import { sessionPath } from "@/utils/routePaths"
import { storedGuestSessions } from "@/utils/sessionIdentity"

export default function NotFound() {
  const navigate = useNavigate()
  /*
   * A guest may have sat in more than one workshop from this browser, so there
   * can be several. The list is sorted, so this picks the same one on every
   * render and in every browser — an arbitrary choice made consistently, which
   * is better than a dead end and better than one that moves.
   */
  const guestSessions = storedGuestSessions()
  const someSession = guestSessions[guestSessions.length - 1] ?? null

  return (
    <StatusScreen
      eyebrow="Not found"
      title="There is nothing at this link."
      detail="The address may be mistyped, or the page has moved."
    >
      {someSession ? (
        <Button onClick={() => navigate(sessionPath(someSession))}>Back to the session</Button>
      ) : (
        <Button onClick={() => navigate(ROUTES.ROOT)}>Back to customers</Button>
      )}
    </StatusScreen>
  )
}
